
<template>
  <span>
    <span v-if="place">{{place}}. {{$t('placePrizesWidget.place')}}:&nbsp;</span>
    <span v-for="(prize, idx) in prizes" :key="idx">
      <prize-widget :prize="prize"/>
      <span v-if="idx == prizes.length-2">&nbsp;{{$t('placePrizesWidget.and')}}&nbsp;</span>
      <span v-else-if="idx != prizes.length-1">,&nbsp;</span>
    </span>
  </span>
</template>

<script>
import PrizeWidget from "./PrizeWidget";

export default {
  name: "PlacePrizesWidget",
  components: {
    PrizeWidget,
  },
  props: {
    place: {
      type: Number,
      required: false
    },
    prizes: {
      type: Array,
      required: true,
    },
  },
  methods: {
  }
};
</script>